// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--jQ3Zf";
export var button = "index-module--button--soK0l";
export var buttonGroup = "index-module--buttonGroup--vA6fB";
export var cases = "index-module--cases--3P9ie";
export var contact = "index-module--contact--yUyF7";
export var content = "index-module--content--TESDl";
export var formWrapper = "index-module--formWrapper--T5OEB";
export var freeExperience = "index-module--freeExperience--eT9EG";
export var imgContent = "index-module--imgContent--zcI-Q";
export var inner = "index-module--inner--dCu2O";
export var listWrapper = "index-module--listWrapper--kLRVC";
export var logo = "index-module--logo--ISsSY";
export var playIcon = "index-module--playIcon--bdozO";
export var removePaddingBottom = "index-module--removePaddingBottom--Q7mV5";
export var removePaddingTop = "index-module--removePaddingTop--5oArG";
export var section = "index-module--section--QaZRy";
export var solutions = "index-module--solutions--ax6Xi";
export var text = "index-module--text--C-1+8";
export var videoContainer = "index-module--videoContainer--hKjKM";